import { InMemoryCache } from "@apollo/client";
import { ApolloClient, DefaultOptions, NormalizedCacheObject } from "@apollo/client/core";
import { WebSocketLink } from "@apollo/client/link/ws";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { getTokenSync } from "csi/keycloak/KeycloakAdapter";

function createApolloClient(): ApolloClient<NormalizedCacheObject> {
	let GRAPHQL_ENDPOINT = (window.location.origin + "/csi-requesthandler/graphql").replace("http", "ws");
	const accessToken = getTokenSync();
	if (accessToken) {
		GRAPHQL_ENDPOINT = GRAPHQL_ENDPOINT + "?access_token=" + getTokenSync();
	}

	const defaultOptions: DefaultOptions = {
		watchQuery: {
			fetchPolicy: "no-cache",
			errorPolicy: "ignore",
		},
		query: {
			fetchPolicy: "no-cache",
			errorPolicy: "all",
		},
	};

	// We still need to use the old SubscriptionClient because it implements 'graphql-ws' subprotocol, which is supported by the server.
	// We cannot use a newer 'graphql-ws' library because it implements a different 'graphql-transport-ws' subprotocol, which is not supported by the server
	// See here: https://www.apollographql.com/docs/react/data/subscriptions/#choosing-a-subscription-library
	const subscriptionClient = new SubscriptionClient(GRAPHQL_ENDPOINT, {
		reconnect: true,
		reconnectionAttempts: 10,
	});

	const link = new WebSocketLink(subscriptionClient);

	const apolloClient = new ApolloClient({
		link: link,
		/*ApolloLink.from([
			onError(({ graphQLErrors, networkError }) => {
				if (graphQLErrors)
					graphQLErrors.forEach(({ message, locations, path }) =>
						console.log(
							`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
						),
					);
				if (networkError) console.log(`[Network error]: ${networkError}`);
			}),
			new HttpLink({
				uri: window.location.origin + '/csi-requesthandler/graphql',
				credentials: 'same-origin'
			})
		]),*/
		cache: new InMemoryCache(),
		defaultOptions: defaultOptions,
	});

	return apolloClient;
}

/**
 * Global Apollo client lazily created
 */
let apolloClient = null;

function getApolloClient(): ApolloClient<NormalizedCacheObject> {
	if (apolloClient == null) {
		apolloClient = createApolloClient();
	}
	return apolloClient;
}

export default getApolloClient;